module.exports = __webpack_public_path__ + "static/media/PFC_F1.5ad748b8.txt";